export enum AssetSelectionType {
  NEW = 'new',
  EXISTING = 'existing',
}

export enum HoldingClassSelectionType {
  NEW = 'new',
  EXISTING = 'existing',
}

export enum FundingSource {
  CapitalCall = 'capitalCall',
  GeneralCapitalOnAccounts = 'generalCapitalOnAccounts',
}

export enum InvestmentTypes {
  InvestmentCreated = 'lpInvestmentCreated',
  InvestmentRealisedCurrencyGain = 'lpInvestmentRealisedCurrencyGain',
  InvestmentRealisedCurrencyLoss = 'lpInvestmentRealisedCurrencyLoss',
}

export enum InvestmentRevaluationOption {
  AllShares = 'allShares',
  ShareClassOnly = 'shareClassOnly',
  DoNotRevalue = 'doNotRevalue',
  ManuallyInput = 'manuallyInput',
}
